/* ==========================================================================
   Grippatch - tema davranislari
   Panel yonetimi, sepet, adet sayaci, hizli ekle, yapiskan header
   ========================================================================== */

const GP = {
  routes: window.gpRoutes || { cart_add: '/cart/add', cart_change: '/cart/change', cart: '/cart' },
};

/* ----------------------------------------------------------- gece/gunduz --- */

/*
 * Tema VARSAYILAN OLARAK KOYU. Ziyaretci basliktaki dugmeye basinca gunduz
 * kipine gecer; secim `localStorage` uzerinde O CIHAZDA saklanir.
 *
 * Nitelik ILK BOYAMADAN ONCE yaziliyor (layout/theme.liquid icindeki kucuk
 * engelleyici betik). Burasi yalnizca dugmeyi baglar ve degistirir - o yuzden
 * burada `defer` gecikmesi renk sicramasi yaratmaz.
 *
 * Isletim sistemi tercihine (`prefers-color-scheme`) BAKILMIYOR: magazanin
 * kimligi koyu, gunduz kipi acik bir istekle aciliyor.
 */

const TEMA_ANAHTAR = 'gp_tema';

function temaOku() {
  return document.documentElement.getAttribute('data-theme') === 'light' ? 'light' : 'dark';
}

function temaYaz(deger) {
  const kok = document.documentElement;
  if (deger === 'light') {
    kok.setAttribute('data-theme', 'light');
  } else {
    kok.removeAttribute('data-theme');
  }

  try {
    /* Secim, YAPILDIGI DONEM ile birlikte saklaniyor. Donem degisince
       (gunduz->gece) ilk boyama betigi bu kaydi silip otomatige donuyor -
       bkz layout/theme.liquid. Otomatik kapaliysa donem `null` yazilir ve
       secim kalici olur. */
    const a = window.gpTema;
    const kayit = { kip: deger, donem: a && a.oto ? a.donem() : null };
    localStorage.setItem(TEMA_ANAHTAR, JSON.stringify(kayit));
  } catch (e) {
    /* gizli sekme / depolama kapali - secim yalniz bu sayfada gecerli olur */
  }

  /* Mobil tarayici adres cubugu rengi de kiple birlikte donsun */
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', deger === 'light' ? '#ffffff' : '#181b23');

  temaDugmeleriniTazele();
}

function temaDugmeleriniTazele() {
  const gunduzMu = temaOku() === 'light';
  document.querySelectorAll('[data-tema-dugme]').forEach((btn) => {
    /* aria-pressed = "gunduz kipi acik mi" */
    btn.setAttribute('aria-pressed', String(gunduzMu));
    /* Etiket YAPILACAK EYLEMI soyler: gunduzdeysen "gece kipine gec" */
    const etiket = gunduzMu ? btn.dataset.etiketGece : btn.dataset.etiketGunduz;
    if (etiket) {
      btn.setAttribute('aria-label', etiket);
      btn.setAttribute('title', etiket);
    }
  });
}

function initTema() {
  temaDugmeleriniTazele();

  /* Dinleyici belge uzerinde ve YALNIZ BIR KEZ: `boot()` her
     `shopify:section:load` olayinda yeniden kosuyor; korumasiz baglanirsa
     ikinci kopya ayni tiklamada tekrar tetiklenir ve kip hic degismez
     (footer akordeonunda bir kez yasandi). */
  if (initTema.bagli) return;
  initTema.bagli = true;

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-tema-dugme]');
    if (!btn) return;
    e.preventDefault();
    temaYaz(temaOku() === 'light' ? 'dark' : 'light');
  });
}

/* ---------------------------------------------------------------- panel --- */

/*
 * 🔴 PANELLER GOVDENIN DOGRUDAN COCUGU OLMALI.
 *
 * OLCULEN HATA (2026-08-24, Faruk bildirdi): koleksiyon ve urun
 * sayfalarinda izgara ikonuna basilinca acilan menu paneli PERDENIN
 * ALTINDA kaliyordu - panel de sayfa gibi karartilip bulaniklasiyordu.
 *
 * SEBEBI: menu paneli `sections/header.liquid` icinde basiliyor, yani
 * `#shopify-section-header` sarmalayicisinin ICINDE. O sarmalayici
 * `position: sticky; z-index: 50` - yani BIR YIGIN BAGLAMI yaratiyor.
 * Yigin baglami icindeki cocuklarin `z-index`i disariya karsi gecersizdir:
 * panelin `z-index: 70`i yalnizca sarmalayicinin ICINDE gecerli, disarida
 * panel "50" olarak davraniyor. Perde (`z-index: 60`) govdenin dogrudan
 * cocugu oldugu icin 50'nin ustune biniyor.
 *
 * Anasayfada gorunmuyordu cunku orada sarmalayici `static` (bkz header.css).
 *
 * COZUM: panelleri govdenin sonuna tasi. Tasima isaretlemeyi degistirmiyor,
 * yalnizca DOM'daki yerini - Liquid ayarlari (menu, kategori sirasi vb.)
 * zaten sunucuda islenmis durumda.
 *
 * `shopify:section:load` her tetiklendiginde bolum yeniden basiliyor ve
 * panel tekrar sarmalayicinin icine dusuyor; bu yuzden islev `boot()`
 * icinde ve idempotent.
 */
function initPanelTasima() {
  document.querySelectorAll('.panel[data-panel]').forEach((el) => {
    if (el.parentElement === document.body) return;
    document.body.appendChild(el);
  });
}


const panels = {
  open: null,
  lastFocus: null,
};

function scrim() {
  return document.querySelector('[data-scrim]');
}

function openPanel(id) {
  const el = document.querySelector(`[data-panel="${id}"]`);
  if (!el) return;

  closePanel();
  panels.lastFocus = document.activeElement;
  panels.open = el;

  /* Koleksiyon filtre kolonu masaustunde surekli goruntur; hidden ile oynamayiz */
  if (el.classList.contains('panel')) el.hidden = false;
  const s = scrim();
  if (s) {
    s.hidden = false;
    requestAnimationFrame(() => s.classList.add('is-on'));
  }
  requestAnimationFrame(() => el.classList.add('is-open'));

  document.body.style.overflow = 'hidden';

  const focusable = el.querySelector('button, [href], input, select, textarea');
  if (focusable) focusable.focus();
}

function closePanel() {
  const el = panels.open;
  if (!el) return;

  el.classList.remove('is-open');
  const s = scrim();
  if (s) s.classList.remove('is-on');

  window.setTimeout(() => {
    if (el.classList.contains('panel')) el.hidden = true;
    if (s) s.hidden = true;
  }, 320);

  document.body.style.overflow = '';
  panels.open = null;

  if (panels.lastFocus) {
    panels.lastFocus.focus();
    panels.lastFocus = null;
  }
}

document.addEventListener('click', (e) => {
  const opener = e.target.closest('[data-open-panel]');
  if (opener) {
    e.preventDefault();
    openPanel(opener.dataset.openPanel);
    return;
  }

  if (e.target.closest('[data-close-panel]') || e.target.closest('[data-scrim]')) {
    closePanel();
  }
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') closePanel();
});

/* Panel icinde odak tuzagi */
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Tab' || !panels.open) return;
  const items = panels.open.querySelectorAll(
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled])'
  );
  if (!items.length) return;
  const first = items[0];
  const last = items[items.length - 1];
  if (e.shiftKey && document.activeElement === first) {
    e.preventDefault();
    last.focus();
  } else if (!e.shiftKey && document.activeElement === last) {
    e.preventDefault();
    first.focus();
  }
});

/* ------------------------------------------------------------- header ---- */

function initStickyHeader() {
  const header = document.querySelector('[data-header]');
  if (!header) return;

  /* Kategori seridi header'in SON satiri. Asagi kaydirirken header
     tamamen gizlenmesin, serit ustte kalsin: gizleme mesafesi
     "header yuksekligi - serit yuksekligi" kadar (bkz header.css
     `.hdr.is-hidden`). Mobilde serit `display:none` oldugu icin
     yukseklik 0 cikar ve header eskisi gibi tamamen gizlenir. */
  const cats = header.querySelector('.hdr__cats');

  /* Yapiskanlik basligin KENDISINDE olamaz: Shopify'in `.shopify-section`
     sarmalayicisi tam baslik boyunda oldugu icin `sticky` yapisacak yer
     bulamiyor (olculdu). Durum siniflari bu yuzden sarmalayiciya yaziliyor;
     CSS de oradan calisiyor (bkz header.css `#shopify-section-header`). */
  const sarmal = header.closest('.shopify-section') || header;
  sarmal.classList.add('hdr-sarmal');

  const setH = () => {
    const kok = document.documentElement;
    kok.style.setProperty('--header-h', `${header.offsetHeight}px`);
    kok.style.setProperty('--hdr-cats-h', `${cats ? cats.offsetHeight : 0}px`);
  };
  setH();
  window.addEventListener('resize', setH);

  /* Sayfadaki yapiskan ogeler (koleksiyon filtre bari vb.) header'in
     GORUNEN alt kenarina yapismali. Header gizlenirken `transform` ile
     yukari kayiyor; `offsetHeight` bunu GORMEZ - o yuzden gercek ekran
     konumu olculuyor. Aksi halde header kayinca bar ile sayfa ustu
     arasinda bosluk kalir ve urunler o bosluktan gorunur. */
  let beklemede = false;
  const setUst = () => {
    beklemede = false;
    const alt = Math.max(0, header.getBoundingClientRect().bottom);
    document.documentElement.style.setProperty('--yapiskan-ust', `${alt}px`);
  };
  setUst();
  window.addEventListener('resize', setUst);

  let last = window.scrollY;
  window.addEventListener(
    'scroll',
    () => {
      const y = window.scrollY;
      const yapisik = y > 8;
      header.classList.toggle('is-stuck', yapisik);
      sarmal.classList.toggle('is-stuck', yapisik);

      /* asagi kaydirirken gizle, yukari kaydirirken goster */
      const gizle = y > 260 && y > last;
      header.classList.toggle('is-hidden', gizle);
      sarmal.classList.toggle('is-hidden', gizle);
      last = y;

      /* Olcum her karede degil, bir sonraki cizim karesinde - kaydirma
         sirasinda gereksiz yerlesim okumasi yapilmasin. */
      if (!beklemede) {
        beklemede = true;
        requestAnimationFrame(setUst);
      }
    },
    { passive: true }
  );

  /* Gizlenme/gorunme gecisi biterken son konumu da yaz (kaydirma durmus
     olabilir; o an olcum tetiklenmezse deger bir kare geride kalir). */
  sarmal.addEventListener('transitionend', (e) => {
    if (e.propertyName === 'transform') setUst();
  });
}

/* Mega menu - klavye ve dokunmatik icin acilir kapanir */
function initNav() {
  document.querySelectorAll('[data-nav-item]').forEach((item) => {
    const trigger = item.querySelector('[data-nav-trigger]');
    if (!trigger) return;

    trigger.addEventListener('click', (e) => {
      const menu = item.querySelector('[data-nav-menu]');
      if (!menu) return;
      /* masaustunde hover zaten aciyor; tiklama linke gitsin */
      if (window.matchMedia('(min-width: 990px)').matches) return;
      e.preventDefault();
      const open = item.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
}

/* Footer menu kolonlari mobilde akordeon (referans zugoshop kalibi).
   Masaustunde kolonlar her zaman acik; sinif ve aria da o zaman kaldiriliyor
   ki ekran okuyucuya "kapanabilir" diye yanlis bilgi gitmesin.
   JS calismazsa `ftr__col--kapanir` hic eklenmez ve kolonlar acik kalir. */
function initFooterAccordion() {
  const kolonlar = [...document.querySelectorAll('.ftr__col')].filter(
    (k) => k.querySelector('[data-ftr-toggle]') && k.querySelector('[data-ftr-panel]')
  );
  if (!kolonlar.length) return;

  const mq = window.matchMedia('(max-width: 749px)');

  const uygula = () => {
    kolonlar.forEach((kol, i) => {
      const dugme = kol.querySelector('[data-ftr-toggle]');
      const panel = kol.querySelector('[data-ftr-panel]');

      if (!mq.matches) {
        kol.classList.remove('ftr__col--kapanir', 'is-open');
        dugme.removeAttribute('aria-expanded');
        return;
      }

      kol.classList.add('ftr__col--kapanir');
      /* Ilk kolon (Kategoriler) acik gelir - referansta da oyle */
      const acik = kol.classList.contains('is-open') || i === 0;
      kol.classList.toggle('is-open', acik);
      dugme.setAttribute('aria-expanded', String(acik));
      if (panel.id) dugme.setAttribute('aria-controls', panel.id);
    });
  };

  uygula();

  /* DIKKAT: `boot()` her `shopify:section:load` olayinda yeniden kosuyor.
     Dinleyiciler korumasiz eklenirse ikinci kopya ayni tiklamada ikinci kez
     tetiklenir; `toggle` iki kez calisip kolon HIC acilmaz. Bu yuzden
     belge/medya dinleyicileri yalniz BIR kez baglaniyor. */
  if (!initFooterAccordion.bagli) {
    initFooterAccordion.bagli = true;

    mq.addEventListener('change', () => initFooterAccordion());

    document.addEventListener('click', (e) => {
      const dugme = e.target.closest('[data-ftr-toggle]');
      if (!dugme || !mq.matches) return;
      const kol = dugme.closest('.ftr__col');
      if (!kol) return;
      const acik = kol.classList.toggle('is-open');
      dugme.setAttribute('aria-expanded', String(acik));
    });
  }
}

/* --------------------------------------------------------------- adet ---- */

function initQty() {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty]');
    if (!btn) return;
    const box = btn.closest('.qty');
    const input = box && box.querySelector('input');
    if (!input) return;

    const step = btn.dataset.qty === 'up' ? 1 : -1;
    const min = parseInt(input.min, 10) || 0;
    const next = Math.max(min, (parseInt(input.value, 10) || 0) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
}

/* --------------------------------------------------------------- sepet --- */

async function cartAdd(variantId, quantity = 1) {
  const res = await fetch(`${GP.routes.cart_add}.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity }] }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.description || 'Sepete eklenemedi');
  }
  return res.json();
}

/*
 * Sepet SAYFASINDAKI satir/ozet kutusunu yerinde tazeler.
 *
 * Neden ayri: `refreshCart()` yalnizca cekmeceyi (`[data-cart-content]`)
 * yeniliyordu. Sepet sayfasinda oneri seridinden "Ekle"ye basildiginda urun
 * sepete GIRIYOR ama ekranda gorunmuyordu - ziyaretcinin sayfayi elle
 * yenilemesi gerekiyordu (Faruk, 2026-08-24). Ayni sorun sayfadaki adet
 * degisimi ve "kaldir" icin de vardi.
 *
 * Bolum kimligi DOM'dan okunuyor: JSON sablonlarinda bolum anahtari `main`
 * ama bunu sabit yazmak sablon yeniden duzenlenirse sessizce kirilir.
 *
 * Sepet bosaldiysa bolum tamamen baska bir govdeye (`.empty`) donuyor ve
 * `[data-cart-page]` gelen HTML'de HIC olmuyor - o durumda sayfa yenileniyor.
 */
async function refreshCartPage() {
  const hedef = document.querySelector('[data-cart-page]');
  if (!hedef) return;

  const sarmal = hedef.closest('.shopify-section');
  const sid = sarmal && sarmal.id ? sarmal.id.replace('shopify-section-', '') : 'main';

  const res = await fetch(`${GP.routes.cart}?section_id=${encodeURIComponent(sid)}`);
  if (!res.ok) return;
  const doc = new DOMParser().parseFromString(await res.text(), 'text/html');

  const taze = doc.querySelector('[data-cart-page]');
  if (!taze) {
    window.location.reload(); // sepet bosaldi - bolumun govdesi tamamen degisti
    return;
  }
  hedef.innerHTML = taze.innerHTML;
}

async function refreshCart() {
  const res = await fetch('/?section_id=cart-drawer');
  if (!res.ok) return;
  const html = await res.text();
  const doc = new DOMParser().parseFromString(html, 'text/html');

  const fresh = doc.querySelector('[data-cart-content]');
  const target = document.querySelector('[data-cart-content]');
  if (fresh && target) target.innerHTML = fresh.innerHTML;

  /* Sepet sayfasindaysak satir listesi + ozet de tazelensin */
  await refreshCartPage();

  // Referans header'da rozet 0 iken de duruyor; gizlemiyoruz, sadece
  // "bos" isaretliyoruz ki CSS soluklastirabilsin.
  const count = doc.querySelector('[data-cart-count]');
  document.querySelectorAll('[data-cart-count]').forEach((el) => {
    if (count) {
      const v = count.textContent.trim();
      el.textContent = v;
      el.classList.toggle('is-empty', v === '0');
    }
  });
}

/* Urun sayfasi formu: normal POST /cart'a gidiyordu, cekmece hic acilmiyordu.
   Form JS ile yakalanip sepete AJAX ekleniyor ve cekmece aciliyor.
   JS calismazsa form kendi haliyle POST etmeye devam eder (yedek yol bozulmaz). */
function initProductForm() {
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-pdp-form]');
    if (!form) return;

    const id = form.querySelector('[data-variant-id]')?.value;
    if (!id) return; // varyant yoksa tarayici normal gonderime devam etsin

    e.preventDefault();
    const btn = form.querySelector('button[type="submit"]');
    const qty = parseInt(form.querySelector('[name="quantity"]')?.value, 10) || 1;

    if (btn) {
      btn.disabled = true;
      btn.classList.add('is-busy');
    }
    try {
      await cartAdd(id, qty);
      await refreshCart();
      openPanel('cart');
    } catch (err) {
      window.alert(err.message);
    } finally {
      if (btn) {
        btn.disabled = false;
        btn.classList.remove('is-busy');
      }
    }
  });
}

function initQuickAdd() {
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();

    const id = btn.dataset.quickAdd;
    if (!id) return;

    btn.disabled = true;
    btn.classList.add('is-busy');
    try {
      await cartAdd(id, 1);
      await refreshCart();
      openPanel('cart');
    } catch (err) {
      window.alert(err.message);
    } finally {
      btn.disabled = false;
      btn.classList.remove('is-busy');
    }
  });
}

/* Sepet icindeki adet degisimi */
function initCartLines() {
  document.addEventListener('change', async (e) => {
    const input = e.target.closest('[data-line-qty]');
    if (!input) return;

    const line = input.dataset.lineQty;
    const qty = Math.max(0, parseInt(input.value, 10) || 0);

    const res = await fetch(`${GP.routes.cart_change}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: qty }),
    });
    if (res.ok) await refreshCart();
  });

  document.addEventListener('click', async (e) => {
    const rm = e.target.closest('[data-line-remove]');
    if (!rm) return;
    e.preventDefault();

    const res = await fetch(`${GP.routes.cart_change}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(rm.dataset.lineRemove), quantity: 0 }),
    });
    if (res.ok) await refreshCart();
  });
}

/* ------------------------------------------------------- siparis notu ---- */

/*
 * Sepet sayfasindaki "Sipariş Notunuz" alani.
 *
 * NEDEN AJAX GEREKIYOR: not `<textarea name="note">` olarak sepet formunun
 * icinde; odemeye basildiginda tarayici onu zaten tasiyor. Ama sayfadaki
 * adet degisimi / satir kaldirma `refreshCartPage()` ile bolumu YENIDEN
 * ciziyor - o an kaydedilmemis bir metin silinirdi. Bu yuzden yazma
 * bitince not sepete yaziliyor ve yeniden cizimde sunucudan geri geliyor.
 *
 * Kaydettikten sonra `refreshCart()` CAGRILMIYOR: tazeleme metin alanini
 * degistirir ve imlec kaybolur. Not sepet toplamini da etkilemiyor.
 *
 * Dinleyiciler BELGE uzerinde ve yalniz bir kez baglaniyor; alan yeniden
 * cizilse de calismaya devam eder (`boot()` her section:load'da kosuyor).
 */
function initCartNote() {
  if (initCartNote.bagli) return;
  initCartNote.bagli = true;

  let bekle;
  let sonYazilan = null;

  const durumYaz = (alan, metin, kayitli) => {
    const kutu = alan.closest('[data-cart-note]');
    const durum = kutu && kutu.querySelector('[data-cart-note-durum]');
    if (!durum) return;
    durum.textContent = metin;
    durum.classList.toggle('is-kayitli', !!kayitli);
  };

  const kaydet = async (alan) => {
    const deger = alan.value;
    if (deger === sonYazilan) return;
    sonYazilan = deger;

    durumYaz(alan, alan.dataset.mKaydediliyor || '', false);
    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: deger }),
      });
      if (!res.ok) throw new Error('not kaydedilemedi');
      durumYaz(alan, deger.trim() ? (alan.dataset.mKaydedildi || '') : '', true);
    } catch (err) {
      sonYazilan = null; // tekrar denenebilsin
      durumYaz(alan, alan.dataset.mHata || '', false);
    }
  };

  document.addEventListener('input', (e) => {
    const alan = e.target.closest('[data-cart-note-alan]');
    if (!alan) return;
    clearTimeout(bekle);
    /* Yazarken her tusa istek atmamak icin bekleme; kullanici durunca yazilir */
    bekle = setTimeout(() => kaydet(alan), 900);
  });

  /* Alandan cikilinca beklemeden yaz - kullanici odemeye gecebilir */
  document.addEventListener('focusout', (e) => {
    const alan = e.target.closest('[data-cart-note-alan]');
    if (!alan) return;
    clearTimeout(bekle);
    kaydet(alan);
  });
}

/* ------------------------------------------------------------ baslat ----- */

function boot() {
  initTema();
  initPanelTasima();
  initStickyHeader();
  initNav();
  initFooterAccordion();
  initQty();
  initQuickAdd();
  initProductForm();
  initCartLines();
  initCartNote();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}

document.addEventListener('shopify:section:load', boot);

window.GPCart = { add: cartAdd, refresh: refreshCart, refreshPage: refreshCartPage, openPanel, closePanel };
window.GPTema = { oku: temaOku, yaz: temaYaz };
